// extracted by mini-css-extract-plugin
export default {"zoomModal":"a4-z","image":"b4-z","button":"c4-z","isOverlayShown":"d4-z"};